import MapHandler from "../map/MapHandler";
import TangibleDictionary from "./TangibleDictionary";

export default class TangibleListener {
  #client: any;
  #host: string;
  #dictionary: TangibleDictionary;
  #maphandler: MapHandler;

  constructor(maphandler: MapHandler) {
    this.#host = "http://localhost:5000";
    this.#dictionary = new TangibleDictionary();
    this.#maphandler = maphandler;
    this.#init();
  }

  #init() {
    const that = this;
    // @ts-ignore
    // no types for tuio library found on npm
    this.#client = new Tuio.Client({ host: this.#host });

    this.#client.on("connect", this.#onConnect);
    this.#client.on("addTuioObject", (evt: any) => {
      this.#onAddTuioObject(that, evt);
    });
    this.#client.on("updateTuioObject", (evt: any) => {
      this.#onUpdateTuioObject(that, evt);
    });
    this.#client.on("removeTuioObject", (evt: any) => {
      this.#onRemoveTuioObject(that, evt);
    });
    this.#client.connect();
    console.log("Tuio client initialized");
  }

  #onConnect() {
    console.log("Tuio connected");
  }

  #onAddTuioObject(that: this, evt: any) {
    //console.log("Tuio object added", evt);
    const cb = that.#dictionary.translateIDtoCallbackHandler(evt.symbolId);
    if (cb) cb.onAddObject(evt, that.#maphandler);
  }

  #onUpdateTuioObject(that: this, evt: any) {
    const cb = that.#dictionary.translateIDtoCallbackHandler(evt.symbolId);
    if (cb) cb.onUpdateObject(evt, that.#maphandler);
  }

  #onRemoveTuioObject(that: this, evt: any) {
    //console.log("Tuio object removed", evt);
    const cb = that.#dictionary.translateIDtoCallbackHandler(evt.symbolId);
    if (cb) cb.onRemoveObject(evt, that.#maphandler);
  }
}
